<template>
  <div class="imgBox min-w-1400">
    <div class="imgBox1 min-w-1400">
      <div class="img1 max-w-1400">
        <!-- <img :src="importedImg1" :alt="altText" class="imgItem1" /> -->
      </div>
    </div>
    <div class="imgBox2 min-w-1400">
      <div class="img2 max-w-1400" >
       <h1>ข้อตกลงความเป็นส่วนตัว</h1>
       <div class="textBox" style="white-space: pre-wrap">{{text}}</div>
       
      </div>
    </div>
 
  </div>
</template>

<script>
// import importedImg1 from "@/page/agorarecursos/components/img/Rectangle1.png";

export default {
  data() {
    return {
      // importedImg1: importedImg1,
      text:`เรา ใส่ใจในความเป็นส่วนตัวของลูกค้าของเรา (“คุณ”) เมื่อคุณใช้บริการแอปพลิเคชันของเรา เรา (“บริการ”) ดังนั้นเราจึงเผยแพร่สิ่งนี้ นโยบายความเป็นส่วนตัว (“นโยบาย”) เพื่อแจ้งให้ลูกค้าทราบถึงนโยบายของเราที่เกี่ยวข้องกับการรวบรวม การใช้ และการเปิดเผยข้อมูลส่วนบุคคลของคุณตามกฎหมายและข้อบังคับที่เกี่ยวข้อง บริษัทของเราจะรวบรวมและใช้ข้อมูลส่วนบุคคลของคุณตามขอบเขตที่คุณยินยอมเท่านั้นเมื่อได้รับอนุญาตอย่างชัดแจ้งจากคุณ
1. การรวบรวมและการใช้ข้อมูล
เรารวบรวมข้อมูลหลายประเภทเพื่อวัตถุประสงค์ต่างๆ เพื่อให้บริการและปรับปรุงบริการของเราแก่คุณ
ประเภทของข้อมูลส่วนบุคคลที่รวบรวม
ในขณะที่ใช้บริการของเรา เราอาจขอให้คุณให้ข้อมูลที่ระบุตัวบุคคลบางอย่างแก่เรา ซึ่งอาจรวมถึงแต่ไม่จำกัดเพียง: (1)ชื่อเต็ม (2)วันเดือนปีเกิด (3)เพศ (4)ที่อยู่อาศัย ที่อยู่, (5) ข้อมูลติดต่อฉุกเฉิน, (6) ข้อมูล ID, (7) ข้อมูลบัญชีธนาคารของผู้รับผลประโยชน์
เมื่อคุณเข้าถึงบริการโดยหรือผ่านอุปกรณ์มือถือ เราอาจรวบรวมข้อมูลบางอย่างโดยอัตโนมัติ รวมถึงแต่ไม่จำกัดเฉพาะ: (1) ตำแหน่งที่ตั้ง (2) กล้อง (3) ข้อมูลโทรศัพท์
วัตถุประสงค์โดยละเอียดสำหรับการรวบรวมข้อมูลส่วนบุคคลดังกล่าวโดยอัตโนมัติประกอบด้วย:
(1) เรารวบรวมข้อมูลตำแหน่งของคุณในพื้นหลังเมื่อคุณใช้บริการ คุณสามารถปิดใช้งานฟังก์ชันการติดตามตำแหน่งของเราในแอปพลิเคชัน
(2) เราต้องการข้อมูลของคุณเกี่ยวกับแอพที่ติดตั้งเพื่อระบุระดับเครดิตของคุณและจัดหาผลิตภัณฑ์ที่เหมาะสมให้กับคุณ
ข้อมูลแอปที่ติดตั้งจะได้รับการเข้ารหัสและอัปโหลดไปยังเซิร์ฟเวอร์ของเรา  ผ่านทางแอปพลิเคชัน แต่เราอาจกรองและลบข้อมูลแอปส่วนบุคคลที่ติดตั้งออกจากเซิร์ฟเวอร์ของเราในครึ่งปีหลัง และเราไม่อาจแบ่งปันข้อมูลนี้กับบุคคลที่สาม หากคุณต้องการลบข้อมูลแอพที่ติดตั้งทันที คุณต้องแจ้งศูนย์บริการลูกค้าของเราทางอีเมล
(3) เราจำเป็นต้องได้รับอนุญาตจากคุณในการใช้กล้องเพื่อถ่ายภาพเอกสาร KYC ของคุณและเอกสารอื่น ๆ ที่จำเป็นสำหรับการขอสินเชื่อสามารถอัปโหลดให้เราได้
(4) เราจะเข้าถึงปฏิทินของคุณเพื่อจุดประสงค์ในการเตือนคุณถึงกำหนดชำระ;
(5) เราต้องการการเข้าถึงแบรนด์อุปกรณ์ รุ่น รุ่นระบบปฏิบัติการ สภาพแวดล้อมเครือข่ายอุปกรณ์ WiFi สถานะอุปกรณ์ ข้อมูลซอฟต์แวร์แอปพลิเคชัน ข้อมูลหน่วยความจำอุปกรณ์ เพื่อให้เราสามารถทราบภาพบุคคลและความชอบของคุณ ซึ่งจะเป็นประโยชน์สำหรับคำแนะนำผลิตภัณฑ์ของเรา
(6) เราตรวจสอบเฉพาะ SMS ทางการเงิน (SMS ทางการเงิน 4 หลัก) ซึ่งรวมถึงผู้ส่ง คำอธิบาย และวันที่ที่ส่งในกล่องจดหมายของผู้ใช้ ซึ่งช่วยให้เราระบุบัญชีต่างๆ ที่ผู้ใช้ถืออยู่และรูปแบบกระแสเงินสดที่เป็นของผู้ใช้ ช่วยเรากำหนดโปรไฟล์ความเสี่ยงของผู้ใช้และจัดทำการวิเคราะห์เครดิตที่เหมาะสมสำหรับผู้ใช้ นอกจากนี้ เรารวบรวมและประมวลผลข้อมูลโทรศัพท์ เช่น บันทึก SMS สำหรับการวิเคราะห์ความเสี่ยง เพื่อประเมินสิทธิ์ของผู้ใช้ในการใช้ผลิตภัณฑ์หรือบริการของเรา (รวมถึงแต่ไม่จำกัดเพียง โดยการประเมินความน่าเชื่อถือของผู้ใช้ พิจารณาว่าผู้ใช้สามารถซื้อผลิตภัณฑ์หรือบริการที่ผู้ใช้ร้องขอ และ/หรือพิจารณาว่าผู้ใช้ มีสิทธิ์ได้รับสิทธิประโยชน์เพิ่มเติมจากผลิตภัณฑ์ที่มีอยู่) เพื่อให้บริการเงินกู้แก่ผู้ใช้ (รวมถึงแต่ไม่จำกัดเฉพาะโดยการประมวลผลธุรกรรมของคุณและประมวลผลการชำระเงินกู้ของผู้ใช้และรวบรว
มการชำระคืนเงินกู้ของผู้ใช้) การตรวจสอบตัวตนของผู้ใช้และ/หรือข้อมูลอื่นๆ ที่ผู้ใช้ให้ไว้กับเรา; ตรวจจับ ต่อสู้ และป้องกันการฉ้อโกง พยายามฉ้อโกง ฟอกเงิน และ/หรือการใช้บริการของเราอย่างผิดกฎหมาย การวิเคราะห์พฤติกรรมของลูกค้า การติดต่อกับหน่วยงานอ้างอิงเครดิตหรือการป้องกันการฉ้อโกง และให้บริการหรือสนับสนุนลูกค้า
เพื่อติดต่อคุณโดยใช้ข้อความ (SMS) (ถ้ามี) ตามวัตถุประสงค์ที่อธิบายไว้ในนโยบายความเป็นส่วนตัวนี้
ข้อมูล SMS จะถูกเข้ารหัสและอัปโหลดไปยังเซิร์ฟเวอร์ของเรา ผ่านทางแอปพลิเคชัน แต่เราอาจกรองและลบข้อมูล SMS ส่วนตัวออกจากเซิร์ฟเวอร์ของเราในอีกครึ่งปีให้หลัง และเราไม่อาจแบ่งปันข้อมูลนี้กับบุคคลที่สาม หากคุณต้องการลบข้อมูล SMS ทันที คุณต้องแจ้งศูนย์บริการลูกค้าของเราทางอีเมล 
ข้อมูลข้างต้นทั้งหมดจะไม่ถูกเก็บไว้อย่างถาวรและจะถูกลบหลังการใช้งาน
การใช้ข้อมูล
เราใช้ข้อมูลที่เก็บรวบรวมเพื่อวัตถุประสงค์ต่างๆ:
(1) เพื่อช่วยเหลือคุณในการลงทะเบียนและขั้นตอนการยืนยัน;
(2) เพื่ออำนวยความสะดวกในการขอสินเชื่อของคุณ;
(3) ทำการวิเคราะห์ความเสี่ยงของสถานะเครดิตของคุณ;
(4) เพื่อสาธิตผลิตภัณฑ์และ/หรือบริการของเรา;
(5) เพื่อเพิ่มความปลอดภัยของผลิตภัณฑ์และ/หรือบริการของเรา;
(6) เพื่อเตือนคุณถึงวันครบกำหนดชำระหนี้；
(7) ใช้มาตรการที่มีประสิทธิภาพในการแก้ปัญหาใด ๆ ที่คุณอาจพบจากการใช้ผลิตภัณฑ์และ/หรือบริการของเราในเวลาที่เหมาะสม；
เราจะเก็บข้อมูลส่วนบุคคลของคุณตราบเท่าที่กฎหมายกำหนดและจำเป็นเพื่อให้บรรลุวัตถุประสงค์ในการรวบรวมและใช้ข้อมูล เมื่อข้อมูลส่วนบุคคลของคุณเกินระยะเวลาการเก็บรักษา เราจะลบข้อมูลส่วนบุคคลของคุณหรือไม่เปิดเผยตัวตนตามข้อกำหนดทางกฎหมายที่บังคับใช้
2. การเปิดเผยข้อมูล
เราอาจเปิดเผยข้อมูลส่วนบุคคลของคุณด้วยความเชื่อโดยสุจริตต่อบุคคลต่อไปนี้เท่านั้น:
• พนักงานที่ได้รับมอบอำนาจจากบริษัทของเราและบริษัทในเครือ รวมถึงผู้สอบบัญชีของบริษัทหรือผู้สอบบัญชีภายนอก สหกรณ์สถาบันการเงิน และ/หรือบุคคลภายนอกที่เกี่ยวข้องกับบริษัทของเรา
• สถาบันสหกรณ์บุคคลที่สาม รวมถึงผู้ให้กู้กองทุน พันธมิตรการชำระเงิน พันธมิตรหลังเงินกู้ ผู้ให้บริการตรวจสอบบุคคลที่สาม ผู้ให้บริการข้อความ พันธมิตรบริการโทรออก
• สำนักงานสินเชื่อ (หน่วยงานรายงานข้อมูลเครดิตประเภทหนึ่ง);
• เจ้าหน้าที่ผู้มีอำนาจที่ดำเนินการสอบสวนทางกฎหมายหรือดำเนินการทางกฎหมาย;
• หน่วยงานอื่นๆ ตามกฎหมาย คำสั่งของรัฐบาล หรือข้อกำหนดทางกฎหมาย
3. สิทธิของผู้ใช้
ในฐานะผู้ใช้บริการ ผู้ใช้มีสิทธิ์เมื่อใดก็ได้ที่จะทราบว่าข้อมูลส่วนบุคคลของคุณถูกเก็บไว้หรือไม่ และสามารถปรึกษาเราเพื่อเรียนรู้เกี่ยวกับเนื้อหาและที่มาของพวกเขา เพื่อตรวจสอบความถูกต้องหรือขอให้เสริม ยกเลิก อัปเดต หรือแก้ไข หรือเพื่อแปลงเป็นรูปแบบนิรนาม หรือเพื่อบล็อกข้อมูลใด ๆ ที่ถือเป็นการละเมิดกฎหมาย รวมทั้งคัดค้านการปฏิบัติด้วยเหตุผลทางกฎหมายใด ๆ และทั้งหมด ควรส่งคำขอถึงเราตามข้อมูลติดต่อที่ระบุไว้ด้านล่าง
4. การปกป้องข้อมูลส่วนบุคคล
เราพยายามรับประกันความปลอดภัยของข้อมูลส่วนบุคคลของคุณผ่านมาตรการรักษาความปลอดภัยภายในและการบังคับใช้นโยบายที่เข้มงวด นอกจากนี้ เรายังกำหนดให้พนักงานของเราและผู้รับจ้างซึ่งเป็นบุคคลภายนอกปฏิบัติตามมาตรฐานและนโยบายความเป็นส่วนตัวที่เกี่ยวข้องของเรา และใช้ความระมัดระวังและมาตรการที่เหมาะสมเมื่อใช้ ส่ง หรือถ่ายโอนข้อมูลส่วนบุคคลของคุณ
ความปลอดภัยของข้อมูลของคุณเป็นสิ่งสำคัญสำหรับเรา แต่โปรดจำไว้ว่าไม่มีวิธีการส่งผ่านอินเทอร์เน็ตหรือวิธีการจัดเก็บข้อมูลทางอิเล็กทรอนิกส์ใดที่ปลอดภัย 100% แม้ว่าเราจะพยายามใช้วิธีการที่เป็นที่ยอมรับในเชิงพาณิชย์เพื่อปกป้องข้อมูลส่วนบุคคลของคุณ แต่เราไม่สามารถรับประกันความปลอดภัยได้อย่างสมบูรณ์
เรายังใช้เทคโนโลยีความปลอดภัยขั้นสูงเพื่อปกป้องข้อมูลส่วนบุคคลของคุณ ซึ่งรวมถึงแต่ไม่จำกัดเพียง: (1) การตรวจจับการบุกรุก; (2) ไฟร์วอลล์; (3) การสแกนไวรัส (4) ชั้นซ็อกเก็ตที่ปลอดภัย; (5) การเข้ารหัสข้อมูล (6) คุกกี้; (7) ปิดโลโก้อัตโนมัติ
เราอาจปรับปรุงนโยบายความเป็นส่วนตัวเป็นครั้งคราว เราจะแจ้งให้คุณทราบเมื่อมีการเปลี่ยนแปลงใดๆ โดยโพสต์นโยบายความเป็นส่วนตัวใหม่ในแอปพลิเคชันนี้
คุณควรทบทวนนโยบายความเป็นส่วนตัวนี้เป็นระยะๆ สำหรับการเปลี่ยนแปลงใดๆ การเปลี่ยนแปลงนโยบายความเป็นส่วนตัวนี้จะมีผลเมื่อมีการโพสต์ในหน้านี้
6. ติดต่อเรา
หากคุณมีคำถามใดๆ เกี่ยวกับนโยบายความเป็นส่วนตัวนี้ โปรดติดต่อเรา โปรดอธิบายรายละเอียดมากที่สุดเท่าที่จะเป็นไปได้ (รวมถึงไม่จำกัดเพียงชื่อและชื่อบัญชีของคุณ เวลาและวันที่ดำเนินการตามข้อร้องเรียนของคุณ คำอธิบายข้อผิดพลาดและรหัสอ้างอิง ชื่อและที่อยู่ติดต่อ รวมถึงที่อยู่อีเมล และอื่นๆ) เมื่อคุณอยู่ การรายงานการไม่ปฏิบัติตามนโยบายความเป็นส่วนตัวนี้`,
      altText: "图片",
    };
  },
};
</script>

<style scoped>
.imgBox {
  display: flex;
  flex-direction: column;
  background-color: #F6F6F6;
}
.imgBox1
{
  display: flex;
  justify-content: center;
  width: 100%;
  min-width: 1400px;
  background-color: "";
}
.imgBox2 {
  display: flex;
  justify-content: center;
  max-width: 1400px;
  padding-top: 40px;
  padding-bottom: 20px;
  height: 2400px;
  background-color: #F6F6F6;
  border-radius: 32px;
  margin: 50px auto;
}

.imgBox3 {
  display: flex;
  justify-content: center;
  width: 100%;
  min-width: 1400px;
  background-color: "";
}

img {
  display: block;
}
.img1 {
  overflow: hidden;
  width: 100%;
}

.img2,
.img4 {
  overflow: hidden;
}

.img3 {
  width: 100%;
  overflow: hidden;
  margin-left: 0;
  margin-right: 0;
}
.imgItem1 {
  width: 100%;
  margin-top: 0;
  margin-bottom: 0;
}
.imgItem2 {
  max-width: 100%;
}
.imgItem3 {
  width: 100%;
  overflow: hidden;
  margin-left: 0;
  margin-right: 0;
}
h1{
  /* margin-top: 50px; */
 margin-left: 490px;
 color: #333333;
 font-size: 40px;
/* border-bottom: 5px solid #04358A; */
display: inline-block
}
.textBox{
  margin-top: 50px;
  margin-left: 100px;
  margin-right: 100px;
  font-size: 18px;
  color: #333333;
}
</style>